import { render, staticRenderFns } from "./VVDSelect.vue?vue&type=template&id=09a99880&scoped=true"
import script from "./VVDSelect.vue?vue&type=script&lang=js"
export * from "./VVDSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a99880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a99880')) {
      api.createRecord('09a99880', component.options)
    } else {
      api.reload('09a99880', component.options)
    }
    module.hot.accept("./VVDSelect.vue?vue&type=template&id=09a99880&scoped=true", function () {
      api.rerender('09a99880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VVDSelect.vue"
export default component.exports